import FilterController from '../Controller'

export default {
  props: [
    'value',
    'allProps',
    'pagination',
    'label',
    'needSearch',
    'filterKey',
  ],

  components: {
    FilterController,
  },

  data() {
    return {
      allFilters: this.value.filters,
    }
  },
  methods: {
    handleFilter(parameters) {
      this.$emit('input', parameters)
    },
  },
}
